import React, { useContext, useState } from "react";
import { useFormik } from "formik";
import { Button } from "react-bootstrap";
import { hashh } from "../api";
import { FormControl, TextField, InputLabel } from "@material-ui/core";
import * as Yup from "yup";
import { makeStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import { Typography } from "@material-ui/core";
import './css/formCampaña.css';
import {Loader} from 'react-block-ui';
import { CampContext } from "../../context/CampContext";


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
    },
    formControl: {
        width: "100%",
    },
    textField: {
        marginTop: theme.spacing(6),
    },
}));
 
function errorText() {
    return (
        <div>
            <p
                style={{
                    marginTop: "0px",
                    fontSize: "10pt",
                    color: "red",
                }}
            >
                ¡ Fecha de Vencimiento debe ser superior a la Fecha de
                Lanzamiento !
            </p>
        </div>
    );
}


const Form = (props) => {

    const {state,setState} = useContext(CampContext)
    const {fechaLanzamiento,fechaVencimiento,habilitada,nroCliente,nombre} = state.currentCamp

    const classes = useStyles();
    const [fecha, setFecha] = useState(true);
    const [loading, setLoading] = useState(false);
    
    //unused?
    const [deshabilitado, setDeshabilitado] = useState(false);

   

    const guardar = () => {
        const fechaLanzamiento = new Date(
            document.getElementById("fechaLanzamiento").value
        );
        const fechaVencimiento = new Date(
            document.getElementById("fechaVencimiento").value
        );
        if (
            fechaVencimiento > fechaLanzamiento &&
            formik.isValid
        ) {

            formik.handleSubmit();
        }
    };

    const handleSubmit = (values) => {
        //guarda en el context y pasa al sig paso
        if(state.action === 'edit'){
            const hash = state.currentCamp.hash //current hash
            const id = state.currentCamp.id //current id

            setState({
                ...state,
                currentCamp: {...values,hash,nroCliente,id},
                form:false,
                param:true
            })
        }else{
            const hash = hashh //new hash
            const nroCliente = props.id 

            setState({
                ...state,
                action:'new',
                currentCamp: {...values,hash,nroCliente},
                form:false,
                param:true
            })
        }
    }

    const validation = Yup.object().shape({
        nombre: Yup.string()
        .max(20, "Debe contener 20 caracteres o menos")
        .required("Campo Requerido"),
        fechaLanzamiento: Yup.string("Debe ser String").required("Campo Requerido"),
        fechaVencimiento: Yup.string("Debe ser String").required("Campo Requerido"),
    });

   
    const formik = useFormik({

        initialValues: {
            fechaLanzamiento,
            fechaVencimiento,
            habilitada,
            nombre,
        },
        validationSchema: validation,
        onSubmit: handleSubmit
    });

    const label = (label) => {
        <p id="label">{label}</p>;
    };


    function formatDate(date) {
        var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + (d.getDate() + 1),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    }

    function handleDateChange() {
        const fechaVencimiento = new Date(
            document.getElementById("fechaVencimiento").value
        );
        const fechaLanzamiento = new Date(
            document.getElementById("fechaLanzamiento").value
        );
        formik.setFieldValue(
            "fechaVencimiento",
            formatDate(fechaVencimiento)
        );
        formik.setFieldValue(
            "fechaLanzamiento",
            formatDate(fechaLanzamiento)
        );
       
        if (fechaVencimiento <= fechaLanzamiento) {
            setFecha(false);
        }else{
            setFecha(true);
        }
    }


    return (
        <div>
            <div id= "divid">
                <Paper id = "paper" className={classes.paper} elevation={3}>
                    <h1 style={{ alignSelf: "center" }}>Nueva Campaña</h1>
                    <Divider
                        style={{
                            width: "70%",
                            alignSelf: "center",
                        }}
                    />
                    <form
                        style={{
                            width: "70%",
                            alignSelf: "center",
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                        }}
                        onSubmit={formik.handleSubmit}
                    >

                        <FormControl className={classes.formControl}>
                            <InputLabel
                                style={{
                                    fontSize: "16pt",
                                    fontFamily: "Roboto",
                                }}
                            >
                                Hash
                            </InputLabel>
                            <TextField
                                className={classes.textField}
                                style={{ marginBottom: "2%" }}
                                placeholder={state.currentCamp.hash || hashh}
                                disabled={true}
                                id="hash"
                                name="hash"
                                variant="outlined"
                            />
                        </FormControl>


                        <FormControl className={classes.formControl}>
                            <InputLabel
                                style={{
                                    fontSize: "16pt",
                                    fontFamily: "Roboto",
                                }}
                            >
                                Nombre
                            </InputLabel>
                            <TextField
                                style={{ marginBottom: "2%" }}
                                className={classes.textField}
                                placeholder="Nombre"
                                label={label("Nombre")}
                                id="nombre"
                                name="nombre"
                                disabled={deshabilitado}
                                onChange={formik.handleChange}
                                value={formik.values.nombre}
                                variant="outlined"
                                helperText= {<Typography component={'span'} style={{fontSize: '14px'}}>{formik.errors.nombre}</Typography>}
                                error={formik.errors.nombre ? true : false}
                            />
                        </FormControl>


                        <FormControl className={classes.formControl}>
                            <InputLabel
                            id="fechalabel">
                                Fecha Lanzamiento
                            </InputLabel>
                            <TextField
                                disabled={deshabilitado}
                                style={{ marginBottom: "2%" }}
                                className={classes.textField}
                                id="fechaLanzamiento"
                                type="date"
                                value={formik.values.fechaLanzamiento}
                                selected={formik.values.fechaLanzamiento}
                                onChange={() => handleDateChange()}
                                helperText={<Typography component={'span'} style={{fontSize: '14px'}}>{formik.errors.fechaLanzamiento}</Typography>}
                                error={formik.errors.fechaLanzamiento ? true : false}
                                variant="outlined"
                            />
                        </FormControl>


                        <FormControl className={classes.formControl}>
                            <InputLabel
                                id="fechalabel">
                                    Fecha Vencimiento
                                </InputLabel>
                                <TextField
                                    disabled={deshabilitado}
                                    style={{ marginBottom: "2%" }}
                                    className={classes.textField}
                                    id="fechaVencimiento"
                                    type="date"
                                    value={formik.values.fechaVencimiento}
                                    selected={formik.values.fechaVencimiento}
                                    onChange={() => handleDateChange()}
                                    helperText={<Typography component={'span'} style={{fontSize: '14px'}}>{formik.errors.fechaVencimiento}</Typography>}
                                    error={formik.errors.fechaVencimiento ? true : false}
                                    variant="outlined"
                                />
                        </FormControl>


                        {fecha === false && errorText()}

                    {!loading && 
                        <Button
                            style={{
                                width: "50%",
                                alignSelf: "center",
                                marginBottom: "2%",
                                marginTop: "2%",
                            }}
                            //type="submit"
                            bsStyle="primary"
                            //disabled={deshabilitado}
                            onClick={guardar}
                        >
                            Siguiente
                        </Button>
                    }

                    {loading && 
                    <div className="loader">
                        <Loader/>
                    </div>
                    }
                    </form>
                </Paper>
            </div>
        </div>
       
    );
};

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/campaña/Form.js